"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "barano-d-ischia": {
    "7e5f7470": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "barano-centro": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec464774": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "buonopane": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "494bf399": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "cesa": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8e1d2f26": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "chiummano": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "665d997d": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "corbore": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f5a7566": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "cretaio": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "01367ed9": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "fiaiano": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87428192": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "matarace": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7ee1b26": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "molara": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7348623d": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "piedimonte": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e3411c66": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "schiappone": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff52966b": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "spalatriello": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "95e4a70e": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "starza": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90f7fedd": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "terranera": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "74899673": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "testa": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d301890": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "testaccio": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0d176f70": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "valotiere": [{
      "hkey": "12ebbf3c",
      "slug": "barano-d-ischia",
      "name": "Barano d'Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;